export default "__VITE_ASSET__DXyoH6lt__"